import Vue from 'vue'
import Router from 'vue-router'
// import store from './store'
// import axios from 'axios'
Vue.use(Router)
let router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            props: true,
            component: {
                render(c) { return c('router-view') },
            },
            meta: {
                requiresAuth: false,
            },
            children: [{
                    path: '',
                    name: 'Home',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/Home/home')
                },
                {
                    path: '/about',
                    name: 'About',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/About/about')
                },
                {
                    path: '/ecoTourism',
                    name: 'EcoTourism',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/EcoTourism/ecoTourism')
                },
                {
                    path: '/programDetails',
                    name: 'ProgramDetails',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/EcoTourism/programDetails')
                },
                {
                    path: '/contact',
                    name: 'contact',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/ContactUs/contact')
                },
                {
                    path: '/media',
                    name: 'media',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/Media/media')
                },
                {
                    path: '/mediaDetails',
                    name: 'mediaDetails',
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ('./components/Media/mediaDetails')
                },
            ]
        },
        {
            path: '/ServerError',
            name: 'ServerError',
            props: true,
            meta: {
                requiresAuth: false,
            },
            component: () =>
                import ('./components/Common/500'),
        },
        {
            path: '*',
            name: '404PageNotFound',
            props: true,
            meta: {
                requiresAuth: false,
            },
            component: () =>
                import ('./components/Common/404'),
        },
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
})
export default router